import { useEffect } from 'react';

import { addUFOCustomMark } from '@atlaskit/react-ufo/custom-mark';

import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';
import { withTransparentErrorBoundary } from '@confluence/error-boundary/entry-points/withErrorBoundary.ts';

type PageLoadMarkFMPProps = {
	timestamp?: number;
};

const UFOLoadMarkFMPComponent = ({ timestamp }: PageLoadMarkFMPProps) => {
	useEffect(() => addUFOCustomMark('fmp', timestamp), [timestamp]);

	return null;
};

export const UFOLoadMarkFMP = withTransparentErrorBoundary({
	attribution: Attribution.BACKBONE,
})(UFOLoadMarkFMPComponent);
